import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import CTABanner from "../components/CTABanner";
import About from "../components/About";
import WhyUs from "../components/WhyUs";
import Reviews from "../components/Reviews";
import Projects from "../components/Projects";
import ServiceArea from "../components/ServiceArea";
import QuoteForm from "../components/QuoteForm";
import Contact from "../components/Contact";
import useHreflangTags from "../hooks/useHreflangTags";

export default function Home() {
  const { t, i18n } = useTranslation();
  useHreflangTags();

  useEffect(() => {
    document.title = t("meta.title");
    const setMeta = (name, content) => {
      const attr = name.startsWith("og:") ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", t("meta.description"));
    setMeta(
      "keywords",
      "elektricien Amsterdam, elektrische storing, groepenkast vervangen, elektricien Noord-Holland, NEN 3140, VvE elektricien, elektricien Amstelveen, elektricien Haarlem"
    );
    setMeta("og:title", t("meta.title"));
    setMeta("og:description", t("meta.description"));
    setMeta("og:type", "website");
    setMeta("og:locale", i18n.language === "hu" ? "hu_HU" : i18n.language === "en" ? "en_GB" : "nl_NL");

    const existing = document.getElementById("ld-local-business");
    if (existing) existing.remove();
    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.id = "ld-local-business";
    ld.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Electrician",
      name: "Ataiwo Installatietechniek",
      image: "https://ataiwo-installatietechniek.nl/logo.png",
      "@id": "https://ataiwo-installatietechniek.nl",
      url: "https://ataiwo-installatietechniek.nl",
      telephone: "+31684099561",
      email: "info@ataiwo-installatietechniek.nl",
      address: { "@type": "PostalAddress", addressLocality: "Amsterdam", addressRegion: "Noord-Holland", addressCountry: "NL" },
      areaServed: ["Amsterdam", "Amstelveen", "Haarlem", "Zaandam", "Purmerend", "Almere", "Hoofddorp", "Hilversum", "Noord-Holland"],
      openingHoursSpecification: [{ "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday"], opens: "08:00", closes: "18:00" }],
      priceRange: "€€",
      description: t("meta.description"),
    });
    document.head.appendChild(ld);
  }, [t, i18n.language]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <CTABanner />
      <About />
      <WhyUs />
      <Reviews />
      <Projects />
      <ServiceArea />
      <QuoteForm />
      <Contact />
    </main>
  );
}
